module.exports = __webpack_public_path__ + "img/globe-slated-01.ead97639.svg";